import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { ReviewsView } from 'views/information-module/ReviewsView';
import { HydrationWrapper } from 'views/common/components';
import { handleAllReviewsSSR } from 'views/information-module/ReviewsView/utils/handleAllReviewsSSR';
import { handleLocationReviewsSSR } from 'views/information-module/ReviewsView/utils/handleLocationReviewsSSR';
import { PAGE_REVIEWS_TYPES } from 'views/information-module/ReviewsView/utils/CONSTANTS';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { checkIfUrlHasCorrectSegmentsTranslations } from 'lib/utils/checkIfUrlHasCorrectSegmentsTranslations';

const ReviewsPage = (props) => {
  const { serverData, pageType } = props;
  return (
    <>
      <HydrationWrapper>
        <ReviewsView serverData={serverData} pageType={pageType} />
      </HydrationWrapper>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { locale } = ctx;
  let serverData = null;
  let pageType = null;
  let translationFiles = null;
  let hreflangData = null;

  if (ctx.query.id != null) {
    pageType = PAGE_REVIEWS_TYPES.location_review;
    hreflangData = generateHreflang(
      PATHS.locationReviews(ctx.query.id).url,
      locale,
    );
    serverData = await handleLocationReviewsSSR(ctx);
    if (serverData.redirect) {
      return serverData;
    }
    translationFiles = [
      'fe_er_reviews_page',
      'fe_er_reviews_title',
      'fe_er_reviews_card',
      'fe_er_my_review',
      'fe_er_common_detailed_rating',
      'fe_er_common_main_widget',
      'fe_er_auth_overlay',
      'fe_er_auth',
      'fe_er_common_reviews',
    ];
  } else {
    pageType = PAGE_REVIEWS_TYPES.all_reviews;
    hreflangData = generateHreflang(PATHS.reviews().url, locale);
    serverData = await handleAllReviewsSSR(ctx);
    if (serverData.redirect) {
      return serverData;
    }
    translationFiles = [
      'fe_er_reviews_page',
      'fe_er_reviews_title',
      'fe_er_reviews_card',
      'fe_er_my_review',
      'fe_er_common_detailed_rating',
      'fe_er_common_main_widget',
    ];
  }

  const isCorrectSegemntTranslation = checkIfUrlHasCorrectSegmentsTranslations(
    ctx,
    hreflangData.canonical,
  );
  if (isCorrectSegemntTranslation.shouldRedirect) {
    return {
      redirect: {
        destination: isCorrectSegemntTranslation.redirectURL,
        permanent: true,
      },
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        ...translationFiles,
      ])),
      ...serverData,
      pageType,
      hreflangData,
      options: {
        showAiChat: true,
      },
    },
  };
}
export default ReviewsPage;
